import { render } from "./OverviewForms.vue?vue&type=template&id=1fdbe77a&scoped=true"
import script from "./OverviewForms.vue?vue&type=script&lang=js"
export * from "./OverviewForms.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=1fdbe77a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdbe77a"]])

export default __exports__